import script from "./ToBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ToBox.vue?vue&type=script&setup=true&lang=js"

import "./ToBox.vue?vue&type=style&index=0&id=09b412eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09b412eb"]])

export default __exports__